import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Table, Header } from 'semantic-ui-react';

import ListRow from './ListRow';

class MarketFactorUploaderList extends Component {
  render() {
    const { allFiles } = this.props;
    const listRow = ListRow();

    const headerRow = (
      <Table.Row>
        <Table.HeaderCell singleLine textAlign='center'>
          Input File
        </Table.HeaderCell>
        <Table.HeaderCell singleLine textAlign='center'>
          Status
        </Table.HeaderCell>
      </Table.Row>
    );

    return (
      <div>
        <div>
          <Header>Market Factor Uploader</Header>
          <Table
            celled
            selectable
            padded
            renderBodyRow={listRow}
            tableData={allFiles}
            headerRow={headerRow}
            size='large'
            compact='very'
            style={{ fontSize: '90%' }}
            striped
          />
        </div>
      </div>
    );
  }
}

MarketFactorUploaderList.propTypes = {
  allFiles: PropTypes.array,
};

MarketFactorUploaderList.defaultProps = {
  allFiles: [],
};

export default MarketFactorUploaderList;
